import { mergeMap } from 'rxjs/operators';
import { ofType } from 'redux-observable';
import { Types, Creators } from '../ducks/emails';
import { Api } from '../../api';

// eslint-disable-next-line
const sendEmailQuote = action$ =>
  action$.pipe(
    ofType(Types.SEND_EMAIL_QUOTE_REQUESTED),
    mergeMap((({ email }) => Api.postEmailQuote(email)
      .then(res => Creators.sendEmailQuoteSuccess(res))
      .catch(err => Creators.sendEmailQuoteError(err)))),
  );

const sendEmailRetirement = action$ =>
  action$.pipe(
    ofType(Types.SEND_EMAIL_RETIREMENT_REQUESTED),
    mergeMap((({ email }) => Api.postEmailRetirement(email)
      .then(res => Creators.sendEmailRetirementSuccess(res))
      .catch(err => Creators.sendEmailRetirementError(err)))),
  );

const sendCallEmail = action$ =>
  action$.pipe(
    ofType(Types.SEND_CALL_EMAIL_REQUESTED),
    mergeMap((({ phone }) => Api.postCallEmail(phone)
      .then(res => Creators.sendCallEmailSuccess(res))
      .catch(err => Creators.sendCallEmailError(err)))),
  );


const epicList = [
  sendEmailQuote,
  sendEmailRetirement,
  sendCallEmail,
];

export default epicList;
